import React, { useState } from 'react'
import { Box } from '@mui/material'
import { LanguageSwitch } from '../../StyledComponents'

function LanguageSwitcher() {
	const [language, setLanguage] = useState('हिंदी')
	const toggleLanguage = () => setLanguage(lang => lang === 'हिंदी' ? 'Eng' : 'हिंदी')

	return (
		<LanguageSwitch onClick={toggleLanguage}>
			<Box sx={{ display: { lg: 'none' } }}>Change Language:</Box>
			{language}
		</LanguageSwitch>
	)
}

export default LanguageSwitcher
